<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('create_slot.edit') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="slot.name" :label="$t('create_slot.name')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="py-0" v-model="slot.station_id" :items="stations" :label="$t('create_slot.station')" item-value="id" item-text="name" :rules="rules_required"></v-autocomplete> 
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="slot.position" type="number" :label="$t('create_slot.position')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row class="px-5 py-0" justify="center">
                        <v-col cols="6" justify="end" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel">
                                {{ $t('create_slot.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save" v-permission="'slot.update'">
                                {{ $t('create_slot.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>   
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { HttpSlotRepository } from '../infrastructure/slot_repository';
import { slotCreateUseCase } from '../application/use_cases/slot_create_use_case';
import { HttpStationRepository } from '../../stations/infrastructure/station_repository';
import { stationIndexUseCase } from '../../stations/application/use_cases/station_index_use_case';

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            slot: {
                name: "",
                station_id: "",
                position: ""
            },
            stations: []
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.create_slot";
    },
    methods: {
        async index(){
            const result = await stationIndexUseCase(HttpStationRepository);
            this.stations = result;
        },
        async save(){
            try {
                const response = await slotCreateUseCase(this.slot, HttpSlotRepository);
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: response.data.success.message
                }
                
                this.$router.go(-1);  
            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        cancel(){
            this.$router.go(-1);
        },
    },
    watch:{
    }
}
</script>

<style lang="css">
</style>